<template>
  <div class="bot" @click="toggleSort(false)">
    <transition name="fade">
      <screen-loading v-if="!loaded" />
      <div class="bot__wrapper" v-else>
        <div class="bot__wrapper__top-content">
          <top />
        </div>
        <use-case class="bot__wrapper__left-content" />
        <div class="bot__wrapper__middle-content">
          <review />
          <response />
        </div>
        <div class="bot__wrapper__right-content">
          <filters />
          <technical />
        </div>
        <div class="bot__wrapper__bottom-content">
          <bottom />
        </div>
      </div>
    </transition>
    <transition name="fade">
      <screen-refreshing v-if="refreshingData" />
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ScreenLoading from '@/components/Screen/Loading.vue'
import ScreenRefreshing from '@/components/Screen/Refreshing.vue'
import UseCase from '@/components/UseCase.vue'
import Filters from '@/components/Filters.vue'
import Technical from '@/components/Technical.vue'
import Review from '@/components/Review.vue'
import Response from '@/components/Response.vue'
import Bottom from '@/components/Bottom.vue'
import Top from '@/components/Top.vue'

export default {
  name: 'Bot',
  components: {
    ScreenLoading,
    ScreenRefreshing,
    UseCase,
    Filters,
    Technical,
    Review,
    Response,
    Bottom,
    Top,
  },
  data() {
    return {
      loaded: false,
    }
  },
  mounted() {
    this.initView(this.$route)

    const locale = this.$route.query.locale
    if (locale) {
      this.$i18n.locale = locale
      this.updateLocale(locale)
    }
  },
  computed: {
    ...mapState({
      useCases: state => state.data.useCases,
      refreshingData: state => state.bot.refreshing.data,
    }),
  },
  methods: {
    ...mapActions({
      setClientId: 'data/setClientId',
      getClientSettings: 'data/getClientSettings',
      toggleSort: 'bot/toggleSort',
      initActiveUseCases: 'refine/initActiveUseCases',
      updateLocale: 'bot/updateLocale',
    }),
    initView(route) {
      this.setClientId(route.params.id)
      this.getClientSettings()
        .then(() => {
          this.initActiveUseCases(this.useCases)
          this.loaded = true
        })
        .catch(e => {
          this.$router.push({ name: 'error-default', params: { error: e } })
        })
    },
  },
}
</script>

<style lang="scss">
$top-height: 62px;
$bottom-height: 40px;

.bot {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: $generic-color-bg-disabled;
  overflow: hidden;

  &__wrapper {
    display: flex;
    flex-wrap: wrap;

    &__top-content {
      @include wrapper(flex-start, 0);

      display: flex;
      justify-content: center;

      @media (min-width: $screen-sm) {
        height: $top-height;
      }
    }

    &__left-content {
      @include wrapper(flex-start);

      @media (min-width: $screen-sm) {
        top: $top-height;
        width: calc(#{$gmap-sidebar-width-tablet} + #{$gutter-md * 2});
        height: calc(100% - #{$bottom-height} - #{$gutter-md} - #{$top-height});
      }

      @media (min-width: $screen-md) {
        width: calc(#{$gmap-sidebar-width-desktop} + #{$gutter-md * 2});
      }
    }

    &__middle-content {
      @include wrapper(center);

      @media (min-width: $screen-sm) {
        top: $top-height;
        right: calc(#{$gmap-sidebar-width-tablet} + #{$gutter-md});
        left: calc(#{$gmap-sidebar-width-tablet} + #{$gutter-md});
        width: calc(100% - #{$gmap-sidebar-width-tablet * 2} - #{$gutter-md * 2});
        height: calc(100% - #{$bottom-height} - #{$gutter-md} - #{$top-height});
      }

      @media (min-width: $screen-md) {
        right: calc(#{$gmap-sidebar-width-desktop} + #{$gutter-md});
        left: calc(#{$gmap-sidebar-width-desktop} + #{$gutter-md});
        width: calc(100% - #{$gmap-sidebar-width-desktop * 2} - #{$gutter-md * 2});
      }
    }

    &__right-content {
      @include wrapper(flex-end);

      @media (min-width: $screen-sm) {
        top: $top-height;
        left: initial;
        width: calc(#{$gmap-sidebar-width-tablet} + #{$gutter-md * 2});
        height: calc(100% - #{$bottom-height} - #{$gutter-md} - #{$top-height});
      }

      @media (min-width: $screen-md) {
        width: calc(#{$gmap-sidebar-width-desktop} + #{$gutter-md * 2});
      }
    }

    &__bottom-content {
      @include wrapper(flex-start);

      display: flex;
      justify-content: center;

      @media (min-width: $screen-sm) {
        top: initial;
        bottom: 0;
        height: calc(#{$bottom-height} + #{$gutter-md * 2});
      }
    }
  }
}
</style>
